module.exports = __webpack_public_path__ + "nu.svg?885340d4719d5347efc1cab986b1f09d";